import { ReactElement } from "react";
import { HStack, IconButton, MenuItem, Text, useDisclosure } from "@chakra-ui/react";
import { MenuButton } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { TComment } from "src/components/common/comments-area/comment/comment.types";
import { useDeleteComment } from "src/components/common/comments-area/hooks/use-delete-comment";
import { ContextMenu } from "src/components/common/context-menu/context-menu";
import { IconPencil, IconTrash } from "src/components/icons";
import { IconThreeDots } from "src/components/icons";
import { WfAlertDialog } from "src/components/modals/wf-alert-dialog/wf-alert-dialog";

interface ICommentContextMenu {
    onEditOpen: () => void;
    entityId: string;
    comment: TComment;
}

export const CommentContextMenu = ({ comment, entityId, onEditOpen }: ICommentContextMenu) => {
    const { t } = useTranslation(["common", "comment"]);
    const disclosureProps = useDisclosure();

    const { deleteComment } = useDeleteComment({ comment, entityId });

    const handleDeleteComment = () => {
        deleteComment();
        disclosureProps.onClose();
    };

    const contextMenuItems: ReadonlyArray<ReactElement> = [
        <MenuItem key="edit" onClick={onEditOpen}>
            <HStack>
                <IconPencil boxSize={3} />
                <Text fontSize="sm" as="span">
                    {t("edit")}
                </Text>
            </HStack>
        </MenuItem>,
        <MenuItem key="delete" onClick={disclosureProps.onOpen}>
            <HStack>
                <IconTrash boxSize={3} />
                <Text fontSize="sm" as="span">
                    {t("delete")}
                </Text>
            </HStack>
        </MenuItem>,
    ];

    return (
        <>
            {disclosureProps.isOpen && (
                <WfAlertDialog
                    onConfirm={handleDeleteComment}
                    {...disclosureProps}
                    confirmButtonText={t("delete")}
                    header={t("delete-comment-header", { ns: "comment" })}
                    body={t("delete-comment-body", { ns: "comment" })}
                />
            )}
            <ContextMenu items={contextMenuItems} placement="bottom-end">
                <MenuButton as={IconButton} size="xs" variant="ghost" _focus={{ bg: undefined }}>
                    <IconThreeDots />
                </MenuButton>
            </ContextMenu>
        </>
    );
};
